export default __webpack_public_path__ + "static/pie-with-variable-radius-4390be8810caa1e39a8b57d8eb193ee0.png";